export default function () {
  $('.fullname-tooltip').tooltip();
  $('.contract-header small').tooltip();
};



// WEBPACK FOOTER //
// ./assets/js/contracts/view.js